import { useRoute } from "wouter";
import SharePointJobForm from "./job-form";

export default function EditSharePointJobPage() {
  const [, params] = useRoute("/sharepoint/jobs/edit/:id");

  return <SharePointJobForm mode="edit" jobId={params?.id} />;
}
